import React, { useMemo } from 'react';
import { useCartContext } from '@/react/store/context';
import { cartClass } from '@/react/data';
const CalcCartFoot = () => {
    const [{ cart }] = useCartContext();
    const round = (num, qty = 2) => {
        return Math.round(num * (10 ** qty)) / (10 ** qty);
    };
    const [square, price] = useMemo(() => {
        const { price, square } = cart.reduce((acc, it) => {
            acc.price += it.type !== 'montage'
                ? +it.price * it.count
                : +it.totalPrice;
            if (it.type !== 'montage' && !isNaN(+it.square))
                acc.square += +it.square * it.count;
            return acc;
        }, { square: 0, price: 0 });
        return [round(square, 3), round(price)];
    }, [cart]);
    return (React.createElement("tfoot", null,
        React.createElement("tr", null,
            React.createElement("td", { colSpan: 2, style: { textAlign: 'right', fontWeight: '600' } },
                "\u0418\u0442\u043E\u0433\u043E \u041C",
                React.createElement("sup", null, "2"),
                ":"),
            React.createElement("td", { className: `${cartClass}__total_square`, style: { textAlign: 'center' } }, square.toFixed(3)),
            React.createElement("td", { colSpan: 2, style: { textAlign: 'right', fontWeight: '600' } }, "\u20BD \u0441 \u041D\u0414\u0421:"),
            React.createElement("td", { className: `${cartClass}__total_price` }, price.toFixed(2)))));
};
export default CalcCartFoot;
